var map = {
	"./de-BE.json": [
		39776,
		9776
	],
	"./de-NL.json": [
		50075,
		75
	],
	"./en-GB.json": [
		24352,
		4352
	],
	"./en-NL.json": [
		38679,
		8679
	],
	"./fr-BE.json": [
		6873,
		6873
	],
	"./nl-BE.json": [
		92951,
		5332
	],
	"./nl-NL.json": [
		62636,
		2636
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23263;
module.exports = webpackAsyncContext;